import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { notificationAnimations } from './notification-animations';
import { NgClass } from '@angular/common';

type NotificationType =
  | 'is-primary'
  | 'is-link'
  | 'is-info'
  | 'is-success'
  | 'is-warning'
  | 'is-danger';

@Component({
  selector: 'ag-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [...notificationAnimations],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class NotificationComponent {
  @Input()
  isColumn: boolean;

  @Input()
  type: NotificationType;

  @Input()
  isMessage = false;

  isVisible = true;

  @Output()
  visibleChange = new EventEmitter();

  @Output()
  dismissed = new EventEmitter();

  @Input()
  get visible(): boolean {
    return this.isVisible;
  }

  set visible(isVisible: boolean) {
    this.isVisible = isVisible;
    this.visibleChange.emit(this.isVisible);
  }

  constructor() {}

  dismiss() {
    this.visible = false;
    this.dismissed.emit();
  }
}
